//import { useState, useEffect } from 'react';
import useStateEnRango from './use-state-en-rango';

function useStateTamEnRango(w, h, minW, maxW, minH, maxH) {
  var _useStateEnRango = useStateEnRango(w, minW, maxW),
      wEnRango = _useStateEnRango[0],
      setWEnRango = _useStateEnRango[1];

  var _useStateEnRango2 = useStateEnRango(h, minH, maxH),
      hEnRango = _useStateEnRango2[0],
      setHEnRango = _useStateEnRango2[1];

  var tam = {
    w: wEnRango,
    h: hEnRango
  };

  function setter(_ref) {
    var w = _ref.w,
        h = _ref.h;
    setWEnRango(w);
    setHEnRango(h);
  }

  return [tam, setter];
}

export default useStateTamEnRango;